module.exports = __webpack_public_path__ + "img/icon_no_data.8b2e99d9.png";